var __decorate=this&&this.__decorate||function(e,t,o,i){var r,a=arguments.length,s=a<3?t:null===i?i=Object.getOwnPropertyDescriptor(t,o):i;if("object"==typeof Reflect&&"function"==typeof Reflect.decorate)s=Reflect.decorate(e,t,o,i);else for(var n=e.length-1;n>=0;n--)(r=e[n])&&(s=(a<3?r(s):a>3?r(t,o,s):r(t,o))||s);return a>3&&s&&Object.defineProperty(t,o,s),s},__awaiter=this&&this.__awaiter||function(e,t,o,i){return new(o||(o=Promise))(function(r,a){function s(e){try{l(i.next(e))}catch(e){a(e)}}function n(e){try{l(i.throw(e))}catch(e){a(e)}}function l(e){var t;e.done?r(e.value):((t=e.value)instanceof o?t:new o(function(e){e(t)})).then(s,n)}l((i=i.apply(e,t||[])).next())})};import{css as e,html as t,unsafeCSS as o}from"lit";import{OrElement as i}from"@openremote/or-element";import{customElement as r,property as a,query as s}from"lit/decorators.js";import{AssetModelUtil as n}from"@openremote/model";import{OrAssetTreeSelectionEvent as l}from"./index";import{i18next as d}from"@openremote/or-translate";import{ifDefined as p}from"lit/directives/if-defined.js";import{styleMap as c}from"lit/directives/style-map.js";import"@openremote/or-vaadin-components/or-vaadin-list-box";import"@openremote/or-vaadin-components/or-vaadin-item";import{when as v}from"lit/directives/when.js";import{DefaultColor2 as h,DefaultColor3 as m,DefaultColor5 as u,Util as g}from"@openremote/core";import f from"lodash.debounce";export class OrAddChangedEvent extends CustomEvent{constructor(e){super(OrAddChangedEvent.NAME,{bubbles:!0,composed:!0,detail:e})}}OrAddChangedEvent.NAME="or-add-asset-changed";let OrAddAssetDialog=class extends i{static get styles(){return e`
            :host{
                border-style: solid;
                border-color: var(--or-app-color5, ${o(u)});
                border-width: 1px 0;
            }
            
            #name-wrapper {
                display: flex;
                flex-direction: column;
                margin-top: 12px;
            }

            #toggle-parent-selector,
            #remove-parent {
                margin: 4px 0 0 5px;
            }

            #name-input,
            #parent-wrapper {
                margin: 10px 0;
            }

            #parent-wrapper {
                display: flex;
                align-items: end;
            }

            #parent {
                flex: 1 1 auto;
            }
            
            #parent-selector {
                max-width: 250px;
                border-left: 1px solid var(--or-app-color5, ${o(u)});
            }
            
            #mdc-dialog-form-add {
                display: flex;
                height: 600px;
                max-height: 600px;
                width: 1000px;
            }

            .msg {
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
                height: 100%;
                font-family: "Segoe UI", Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
                font-size: 14px;
            }

            #asset-type-option-container {
                padding: 15px;
                flex: 1 1 auto;
                overflow: auto;
                max-width: 100%;
                font-size: 16px;
            }

            #type-list-filter {
                padding: 7px;
                background-color: var(--or-app-color2, ${o(h)}))
            }
            
            #filterInput{
                width: 100%;
            }

            #type-list {
                overflow: auto;
                text-transform: capitalize;
            }

            #type-list-container {
                display: flex;
                flex-direction: column;
                width: 300px;
                border-right: 1px solid var(--or-app-color5, ${o(u)});
            }

            #type-title {
                display: flex;
                align-items: center;
                margin: 9px 4px;
            }

            #type-description {
                text-transform: capitalize;
                color: var(--or-app-color3, ${o(m)});
                margin-left: 10px;
                font-size: 18px;
                font-weight: bold;
                font-family: "Segoe UI", Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
            }

            .heading,
            .mdc-list-group__subheader {
                text-transform: uppercase;
                font-family: "Segoe UI", Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol";
                font-weight: bolder;
                line-height: 1em;
                color: var(--or-app-color3, ${o(m)});
                letter-spacing: 0.025em;
                font-size: 14px;
                margin: 20px 0 10px;
            }

            .mdc-list-group__subheader {
                margin: 20px 0 0 16px;
            }
        `}constructor(){super(),this.selectedAttributes=[],this.showParentAssetSelector=!1,this.selectedChildAssetType="",this.typeFilter="",this.name="New Asset",this.addEventListener(l.NAME,e=>{this.parent=e.detail.newNodes[0].asset})}render(){let e=e=>e.map(e=>({styleMap:{"--or-icon-fill":e.colour?"#"+e.colour:"unset"},icon:e.icon,text:g.getAssetTypeLabel(e),value:e.name,data:e})).sort(g.sortByString(e=>e.text)),o=e(this.agentTypes),i=e(this.assetTypes),r=e=>{var t;return(null!=(t=e.text)?t:"").toLowerCase().includes(this.typeFilter.toLowerCase())},a=o.filter(r),s=i.filter(r),n=(e,o=!1)=>t`
      <or-vaadin-list-box
        id="${o?"agent-list":"asset-list"}"
        style="padding: var(--lumo-space-s) 0;"
        @selected-changed=${t=>this.onTypeChanged(o,e[t.detail.value])}
      >
        <b style="padding: 0 var(--lumo-space-s);"
          ><or-translate value=${o?"agents":"assets"}></or-translate
        ></b>
        ${e.map(e=>{var o,i,r;return t`
            <or-vaadin-item style=${c(null!=(o=e.styleMap)?o:{})}>
              <div style="display: flex; align-items: center; gap: 8px;">
                <or-icon icon=${p(e.icon)}></or-icon>
                <span style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
                  ${null!=(r=null!=(i=e.text)?i:e.value)?r:t`<or-translate value="unknown"></or-translate>`}
                </span>
              </div>
            </or-vaadin-item>
          `})}
      </or-vaadin-list-box>
    `,l=this.parent?this.parent.name+" ("+this.parent.id+")":d.t("none");return t`
      <div class="col" style="height: 100%;">
        <form id="mdc-dialog-form-add" class="row">
          <div id="type-list-container" class="col">
            <div id="type-list-filter">
              <or-vaadin-text-field
                id="filterInput"
                placeholder=${d.t("search")}
                @input=${f(()=>{var e;return this.typeFilter=null!=(e=this._filterInput.value)?e:""},200)}
              >
                <or-icon slot="suffix" icon="magnify"></or-icon>
              </or-vaadin-text-field>
            </div>
            <div id="type-list">
              ${v(o.length>0,()=>n(a,!0))}
              <hr style="color: white;" />
              ${v(i.length>0,()=>n(s,!1))}
            </div>
          </div>

          <div id="asset-type-option-container" class="col">
            ${!this.selectedType?t`<div class="msg"><or-translate value="noAssetTypeSelected"></or-translate></div>`:this.getTypeTemplate(this.selectedType,l)}
          </div>
          ${!this.showParentAssetSelector?t``:t`<or-asset-tree
                  id="parent-selector"
                  class="col"
                  .showDeselectBtn="${!1}"
                  .showSortBtn="${!1}"
                  selectedNodes
                  readonly
                ></or-asset-tree>`}
        </form>
      </div>
    `}getTypeTemplate(e,o){var i,r;if(!e.name)return!1;let a=n.getAssetTypeInfo(e.name),s=null==(i=null==a?void 0:a.attributeDescriptors)?void 0:i.filter(e=>!e.optional),l=null==(r=null==a?void 0:a.attributeDescriptors)?void 0:r.filter(e=>!!e.optional);return t`
      <div id="type-title">
        <or-icon
          style="--or-icon-fill: ${e.colour?"#"+e.colour:"unset"}"
          id="type-icon"
          .icon="${e.icon}"
        ></or-icon>
        <or-translate id="type-description" .value="${g.getAssetTypeLabel(e)}"></or-translate>
      </div>
      <div id="name-wrapper">
        <or-vaadin-text-field
          id="name-input"
          minlength="1"
          maxlength="1023"
          required
          value=${this.name}
          @change=${e=>{let t=e.currentTarget;t.checkValidity()&&this.onNameChanged(t.value)}}
        >
          <or-translate slot="label" value="name"></or-translate>
        </or-vaadin-text-field>
        <div id="parent-wrapper">
          <or-vaadin-text-field id="parent" readonly value=${o}>
            <or-translate slot="label" value="parent"></or-translate>
          </or-vaadin-text-field>
          <or-vaadin-button
            id="remove-parent"
            theme="icon"
            ?disabled=${!this.parent}
            @click=${()=>this._onDeselectClicked()}
          >
            <or-icon icon="close"></or-icon>
          </or-vaadin-button>
          <or-vaadin-button
            id="toggle-parent-selector"
            theme="icon"
            @click=${()=>this._onToggleParentAssetSelector()}
          >
            <or-icon icon=${this.showParentAssetSelector?"pencil-off":"pencil"}></or-icon>
          </or-vaadin-button>
        </div>
      </div>

      ${!s?t``:t`
              <div>
                <div class="heading"><or-translate value="attribute_plural"></or-translate></div>
                <div style="display: grid">
                  ${s.sort(g.sortByString(e=>e.name)).map(e=>t`
                        <or-vaadin-checkbox
                          readonly
                          checked
                          label=${g.getAttributeLabel(void 0,e,void 0,!0)}
                        ></or-vaadin-checkbox>
                      `)}
                </div>
              </div>
            `}
      ${!l?t``:t`
              <div>
                <div class="heading">${d.t("optional_attributes")}</div>
                <or-vaadin-checkbox-group theme="vertical" .value=${this.selectedAttributes.map(e=>e.name)}>
                  ${l.sort(g.sortByString(e=>e.name)).map(e=>t`
                      <or-vaadin-checkbox
                        value=${e.name}
                        label=${g.getAttributeLabel(void 0,e,void 0,!0)}
                        @change=${t=>t.currentTarget.checked?this.selectedAttributes.push(e):this.selectedAttributes.splice(this.selectedAttributes.findIndex(t=>t.name===e.name),1)}
                      >
                      </or-vaadin-checkbox>
                    `)}
                </or-vaadin-checkbox-group>
              </div>
            `}
    `}onNameChanged(e){this.name=e,this.onModified()}onTypeChanged(e,t){return __awaiter(this,void 0,void 0,function*(){yield this.updateComplete,this.selectedAttributes=[],this.selectedType=t.data;let o=e?this.assetList:this.agentList;o&&(o.selected=void 0),this.onModified()})}onModified(){this.dispatchEvent(new OrAddChangedEvent({name:this.name,descriptor:this.selectedType}))}_onToggleParentAssetSelector(){this.showParentAssetSelector=!this.showParentAssetSelector}_onDeselectClicked(){this.parent=void 0}};__decorate([a({attribute:!1})],OrAddAssetDialog.prototype,"config",void 0),__decorate([a({attribute:!1})],OrAddAssetDialog.prototype,"agentTypes",void 0),__decorate([a({attribute:!1})],OrAddAssetDialog.prototype,"assetTypes",void 0),__decorate([a({attribute:!1})],OrAddAssetDialog.prototype,"parent",void 0),__decorate([a({attribute:!1})],OrAddAssetDialog.prototype,"selectedType",void 0),__decorate([a({attribute:!1})],OrAddAssetDialog.prototype,"selectedAttributes",void 0),__decorate([a({attribute:!1})],OrAddAssetDialog.prototype,"showParentAssetSelector",void 0),__decorate([a({attribute:!1})],OrAddAssetDialog.prototype,"selectedChildAssetType",void 0),__decorate([a({type:String})],OrAddAssetDialog.prototype,"typeFilter",void 0),__decorate([s("#name-input")],OrAddAssetDialog.prototype,"nameInput",void 0),__decorate([s("#agent-list")],OrAddAssetDialog.prototype,"agentList",void 0),__decorate([s("#asset-list")],OrAddAssetDialog.prototype,"assetList",void 0),__decorate([s("#filterInput")],OrAddAssetDialog.prototype,"_filterInput",void 0),OrAddAssetDialog=__decorate([r("or-add-asset-dialog")],OrAddAssetDialog);export{OrAddAssetDialog};